import React from 'react';
import { Navbar } from '../../components';
import { ReferenceHeader } from '../../containers';

const Reference = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <ReferenceHeader />
        </div>
    </div>
  )
}

export default Reference